import * as React from 'react';
import { ETheme } from '../types';
import { clsx } from 'clsx';
import { UiKitThemeContext, useUiKitThemeContext } from '../internal/context';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const getThemeClassName = theme => {
  return clsx({
    'design-theme--light': theme === ETheme.light,
    'design-theme--dark': theme === ETheme.dark,
    'design-theme--colored': theme === ETheme.colored,
    'design-theme--onOverlay': theme === ETheme.onOverlay
  });
};
export const useUiKitTheme = () => {
  const {
    theme
  } = useUiKitThemeContext();
  return {
    theme,
    themeClassName: getThemeClassName(theme)
  };
};
export const Theme = _ref => {
  let {
    theme,
    children,
    displayContents
  } = _ref;
  const context = React.useMemo(() => ({
    theme: theme
  }), [theme]);
  return /*#__PURE__*/_jsx(UiKitThemeContext.Provider, {
    value: context,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles['container'], getThemeClassName(context.theme), displayContents && styles['display_contents']),
      children: children
    })
  });
};